import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import SearchBar from "./components/searchbar";
import About from './pages/about';
import SuggestionBox from './pages/suggestionbox';
import Login from './pages/login';
import Privacy from './pages/privacy';
import Terms from './pages/terms';
import Settings from './pages/settings';
import Dashboard from './pages/dashboard';
import Layout from './pages/layout';
import './components/footer.css';
import './pages/header';
import './components/searchbar.css'; // !!!!Need this here to keep main page aesthetics!!!!
import NewEvent from './pages/newevent';
import { PassportProvider } from './passport'; // 👈 import it
import EventEditor from './pages/eventeditor';
import Faq from './pages/faq';
import { useNavigate } from "react-router-dom";
import Speakeasy from './pages/speakeasy';
import RequireAuth from './pages/requireauth'; // Adjust to your file location
import QrCodeInvite from './pages/qrcodeinvite';
import OpenEvents from './pages/openevents'; 
import EventViewer from './pages/eventviewer';
import TestInviteButton from "./pages/testinvitebutton";
import supabase from "./config/supabaseClient";
import HelpPage from './pages/helppage'; 
import BetaGate from './config/betagate';
import AttendingEvents from './pages/attending';
import ResetPassword from './pages/resetpassword';



function App() {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();


const handleSearch = (event) => {
  event.preventDefault();
  const trimmed = searchQuery.trim().toUpperCase();
  if (trimmed) {
    navigate(`/speakeasy?vrc=${trimmed}`);
  }
};

  console.log("📡 App rendered with current route:", window.location.pathname);
  console.log("📍 App loaded at:", window.location.pathname);


  
  return (
    <PassportProvider>
       <BetaGate>
    <div className="app">
 
      <Routes>
        <Route path="/" element={
          <Layout>
            {console.log("🏠 Rendering homepage route")}
              <div className="search-wrapper">
                <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} handleSearch={handleSearch} />
        </div>
      </Layout>
    } />


    <Route path="/settings" element={
        <Layout><Settings /></Layout>
    } />

    <Route path="/dashboard" element={
        <Layout><Dashboard /></Layout>
    } />

    <Route path="/newevent" element={
        <Layout><NewEvent /></Layout>
    } />

    <Route path="/event/:id/edit" element={
        <Layout>
          <RequireAuth>
            <EventEditor />
          </RequireAuth>
        </Layout>
    } />

    <Route path="/event/:id" element={
        <Layout><EventViewer /></Layout>
    } />

    <Route path="/qrcodeinvite/:eventId" element={
        <QrCodeInvite />
    } />

    <Route path="/invite/:qrToken" element={<QrCodeInvite />} />

    <Route path="/attending" element={<Layout><AttendingEvents /></Layout>} />



{/* General Public Access */}
  <Route path="/about" element={<Layout><About /></Layout>} />
  <Route path="/suggestionbox" element={<Layout><SuggestionBox /></Layout>} />
  <Route path="/login" element={<Layout><Login /></Layout>} />
  <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
  <Route path="/terms" element={<Layout><Terms /></Layout>} />
  <Route path="/faq" element={<Layout><Faq /></Layout>} />
  <Route path="/speakeasy" element={<Layout><Speakeasy /></Layout>} />
  <Route path="/openevents" element={<Layout><OpenEvents /></Layout>} />
  <Route path="/helppage" element={<Layout><HelpPage /></Layout>} />
  <Route path="/resetpassword" element={<Layout><ResetPassword /></Layout>} />

  {/* <Route path="/test-invite" element={<TestInviteButton />} /> */}

</Routes>
    </div>
     </BetaGate>
    </PassportProvider>
    
  );
}

export default App;
